<template>

<v-row justify="center">
    <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="text-h6">
            {{ $t('titles.events') }}
          </v-list-item-title>
          <v-list-item-subtitle>
            {{ $t('titles.select') }}
          </v-list-item-subtitle>
        </v-list-item-content>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <router-link :to="{name: 'EventList', params: { apihost: apihost, city: city, lock: lock }}" tag="span">
              <v-btn 
                depressed
                color="light-grey"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon dark> mdi-layers </v-icon>
              </v-btn>
            </router-link>
          </template>
          <span>{{ $t('hints.eventlist') }}</span>
        </v-tooltip>
    </v-list-item>

    <!-- <v-list-item> -->
      <!-- <v-autocomplete
          color="white"
          hide-no-data
          hide-selected
          hide-details
          :label="$t('hints.search')"
          :placeholder="$t('hints.invite')"
          prepend-icon="mdi-database-search"
          return-object
          style="margin-left:12px"
          dense
      ></v-autocomplete> -->
    <!-- </v-list-item> -->
    
    <router-view @show_event="show_event" @redraw_events="redraw_events" :lock="lock" :apihost="apihost" :city="city">
    </router-view>
    <v-overlay :value="lock" :absolute=true opacity=0.3>
    </v-overlay>
</v-row>
</template>

<script>

  export default {
    props: {
        city: String,
        apihost: String,
        lock: Boolean
    },
    methods: {
      show_event(id) {
        this.$emit('show_event', id);
      },
      redraw_events() {
        this.$emit('redraw_events');
      }
    },
    watch: {
      city() {
        if (this.$route.path != '/')
          this.$router.push('/');
      }
    }
  }
</script>